import Authentication from 'app/developer-v3/pages/authentication';
import AuthenticationEditor from 'app/developer-v3/pages/authentication/AuthenticationEditor';
import AuthenticationFieldEditor from 'app/developer-v3/pages/authentication/AuthenticationFieldEditor';
import { SERVICE_TYPE } from 'app/developer-v3/constants';
import { assignParams } from 'app/common/utils/RouterUtils';
import { warnIfLeavingUnsavedChanges } from 'app/developer-v3/utils';

export default {
  ...assignParams({ serviceType: SERVICE_TYPE.authentication }),
  routes: {
    '.': Authentication,
    edit: {
      component: AuthenticationEditor,
      onLeave: warnIfLeavingUnsavedChanges,
    },
    fields: {
      routes: {
        ':fieldKey': AuthenticationFieldEditor,
      },
    },
  },
};
